import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import { momentHelper } from '../../report/helpers'

const DEFAULT_ROW = 31
class PrintReportProductTransactionImport extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    getDate() {
        let _date = ''
        if(this.props.isRange==='true') {
            _date = ' ระหว่างวันที่ '+this.props.startDate+' ถึงวันที่ '+this.props.endDate
        } else {
            if ((this.props.month===''||this.props.month==='0'||this.props.month==='00')&&(this.props.day===''||this.props.day==='0'||this.props.day==='00')) {
                _date = ' ประจำปี '+this.props.year
            } else if (this.props.day===''||this.props.day==='0'||this.props.day==='00') {
                _date = ' ประจำเดือน '+momentHelper.getMonthText(this.props.month)+' ปี '+this.props.year
            } else {
                _date = ' ประจำวันที่ '+this.props.day+' เดือน '+momentHelper.getMonthText(this.props.month)+' ปี '+this.props.year
            }
        }
        return _date
    }

    getDataFormat(data) {
        let check_date = []
        let dataFormat = []
        let productcode = []
        let cost_per_unit = []
        let description = []
        let price_per_unit = []
        let quantity = []
        let unit = []
    
        data = data.map((item,index)=>{
            if (item.added_date!==''&&item.added_date!==null&&item.added_date!==undefined&&item.added_date.split(' ').length>0)
                item.added_date = item.added_date.split(' ')[0]
            
            return item
        })
    
        for (var i=0;i<data.length;i++) {
            if (check_date.indexOf(data[i].added_date)===-1) {
              check_date.push(data[i].added_date)
            }
        }
    
        for (var i=0;i<check_date.length;i++) {
            for (var j=0;j<data.length;j++) {
              if (check_date[i]===data[j].added_date) {
                productcode.push(data[j].productcode)
                cost_per_unit.push(data[j].cost_per_unit)
                description.push(data[j].description)
                price_per_unit.push(data[j].price_per_unit)
                quantity.push(data[j].quantity)
                unit.push(data[j].unit)
              }
            }
            dataFormat.push({
              added_date: check_date[i],
              meta: {
                productcode: productcode,  
                cost_per_unit: cost_per_unit,
                description: description,
                price_per_unit: price_per_unit,
                quantity: quantity,
                unit: unit
              }
            })
            productcode = []
            cost_per_unit = []
            description = []
            price_per_unit = []
            quantity = []
            unit = []
        }
        
        return dataFormat  
      }

    loadData() {
        if (this.props.isRange==='false'&&this.props.year!==undefined&&this.props.month!==undefined&&this.props.day!==undefined&&this.props.groupId!==undefined&&this.props.recordType!==undefined) {
            ReportStore.loadReportProductTransactionRecord(this.props.year,this.props.month,this.props.day,this.props.groupId,this.props.recordType,'',(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{

            })   
        } else if (this.props.isRange==='true'&&this.props.startDate!==undefined&&this.props.endDate!==undefined&&this.props.groupId!==undefined&&this.props.recordType!==undefined) {
            ReportStore.loadReportProductTransactionRecordRange(this.props.startDate,this.props.endDate,this.props.groupId,this.props.recordType,'',(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{
                
            })
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    
    getSummary(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
        }) 
        return total
    }

    getPagination(data) {
        let newData = []
        let allData = []
        // let checkDate = undefined
        let checkRow = 0
        // data = data.map((item,index)=>{
        //     if (item.added_date!==''&&item.added_date!==null&&item.added_date!==undefined&&item.added_date.split(' ').length>0)
        //         item.added_date = item.added_date.split(' ')[0]
            
        //     return item
        // })
        
        data.forEach((item,index)=>{
            if (checkRow<DEFAULT_ROW) {
                newData.push(item)
                checkRow++
                // if (checkDate!==item.added_date) {
                //     checkRow = checkRow+2
                // }
                // checkDate = item.added_date
            }
                
            if (checkRow>=DEFAULT_ROW-1||index===data.length-1) {
                allData.push(newData)
                checkRow = 0
                newData = []
            }
        })  
        
        return allData
    }

    renderDocDate(date) {
        return(
          <div className='bd-date'><b>{date}</b></div>
        )
      }
    
      renderCol(datas,key,status=true) {
        return(
          datas.map((data, index) => {
            return(
              <div key={index} className={(key==='productcode'?'font-18 ':'')+(datas.length-1===index&&key==='amount'?'bd-sum':'')}>
                {data!==''?data:<br/>}
              </div>
            )
          })
        )
      }

    // renderRowData(items,indexs) {

    //     if (items.length===0) {
    //       return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
    //     } else {
    //       return(
    //         items.map((item,index) => {
    //           return(
    //             <tr key={index}>
    //               <td>
    //                 {this.renderDocDate(item.added_date)}
    //                 {/* {this.renderCol(item.meta.productcode,'productcode')} */}
    //               </td>
    //               {/* <td className='text-center'>
    //                 <div className='bd-date'><br/></div>
    //                 {this.renderCol(item.meta.productcode,'productcode')}
    //               </td> */}
    //               <td className='text-left' style={{whiteSpace:'nowrap',width:'100px',overflow:'hidden',textOverflow:'ellipsis'}}>
    //                 <div className='bd-date'><br/></div>
    //                 {this.renderCol(item.meta.description,'description')}
    //               </td>
    //               <td className='text-center'>
    //                 <div className='bd-date'><br/></div>
    //                 {this.renderCol(item.meta.quantity,'quantity')}
    //               </td>
    //               <td className='text-center'>
    //                 <div className='bd-date'><br/></div>
    //                 {this.renderCol(item.meta.unit,'unit')}
    //               </td>
    //               <td className='text-right'>
    //                 <div className='bd-date'><br/></div>
    //                 {this.renderCol(item.meta.cost_per_unit,'cost_per_unit')}
    //               </td>
    //               {/* <td className='text-right'>
    //                 <div className='bd-date'><br/></div>
    //                 {this.renderCol(item.meta.price_per_unit,'price_per_unit')}
    //               </td> */}
    //             </tr>
    //           )
    //         })
    //       )
    //     }
    // }

    renderRecordType(item,recordType){
      if(recordType===''){
        return (<td className='text-center'><div className=''>{item.record_type==='import'?'เข้า':item.record_type==='export'?'ออก':''}</div></td>)
      }else{
        return (<td className='text-right'>{this.getNumberFormat(item.cost_per_unit)}</td>  )
      }
    }

    renderRowData(items,indexs,recordType) {
        if (items.length===0) {
            return(<tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>)
        } else {
          return(
            items.map((item,index) => {
              
              return(
                <tr key={index}>
                  <td className='text-center'>
                    {item.record_date}
                  </td>
                  <td className='text-center'>
                    {item.record_time}
                  </td>
                  <td className='text-left' style={{whiteSpace:'nowrap',width:'100px',overflow:'hidden',textOverflow:'ellipsis'}}>
                    {item.description}
                  </td>
                  <td className='text-center'>
                    {item.quantity}
                  </td>
                  <td className='text-center'>
                    {item.unit}
                  </td>                          
                  {this.renderRecordType(item,recordType)}       
                  <td className='text-center'>{item.record_type==='import'?item.request_by:item.car_registration_no}</td>
                  <td className='text-center'>{item.record_type==='import'?item.response_by:item.request_by}</td>
                </tr>
              )
            })
          )
        }
    }

    renderHeadCol(recordType) {
        if (recordType==='') {
          return([            
            <td key={0} className='text-center' style={{width:'80px'}}>ประเภท</td>,
            <td key={1} className='text-center' style={{width:'200px'}}>บ.ผู้ขาย/ทะเบียนรถ</td>,
            <td key={2} className='text-center' style={{width:'200px'}}>ชื่อผู้นำเข้า/เบิก</td>
          ])
        } else if (recordType==='import') {
          return([
            <td key={0} className='text-center' style={{width:'100px'}}>ต้นทุน</td>,
            <td key={1} className='text-center' style={{width:'100px'}}>บ.ผู้ขาย</td>,
            <td key={2} className='text-center' style={{width:'200px'}}>ชื่อผู้นำเข้า</td>
          ])  
        } else if (recordType==='export') {
          return([
            <td key={0} className='text-center' style={{width:'100px'}}>ต้นทุน</td>,
            <td key={1} className='text-center' style={{width:'100px'}}>ทะเบียนรถ</td>,
            <td key={2} className='text-center' style={{width:'200px'}}>ชื่อผู้เบิก</td>
          ])  
        }
      }

    renderTable(items,indexs,length) {
        let {recordType} = this.props
        return(
            <table className='table table-responsive table-report-product-transaction-import'>
                <tbody>
                    <tr>
                        <td className='text-center' style={{width:'110px'}}>วันที่</td>
                        <td className='text-center' style={{width:'90px'}}>เวลา</td>
                        <td className='text-center' style={{width:'280px'}}>ชื่อรายการ</td>
                        <td className='text-center' style={{width:'60px'}}>จำนวน</td>
                        <td className='text-center' style={{width:'60px'}}>หน่วย</td>                                                
                        {this.renderHeadCol(recordType)}
                    </tr>
                    {this.renderRowData(items,indexs,recordType)}
                    {length-1===indexs?
                    <tr>
                        <td colSpan={3} className='text-right'>ยอดรวมสุทธิ</td>
                        <td className='text-center'>{this.getNumberFormat(this.getSummary('quantity'))}</td>
                        <td className='text-right'></td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('cost_per_unit'))}</td>
                        <td colSpan={recordType===''?4:2} className='text-right'></td>
                    </tr>
                    :''}
                </tbody>   
            </table>
        )
    }

    renderComponentPage(items,indexs,length) {
        return(  
            <div className='font-print' key={indexs}>
                <header className="text-center">
                    <h2>
                        {this.props.title+(this.props.recordType==='import'?'รับเข้า':this.props.recordType==='export'?'เบิก':'รับเข้าและเบิก')+this.getDate()}
                    </h2>
                </header>
                <div>
                    {this.renderTable(items,indexs,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length===0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title+(this.props.recordType==='import'?'รับเข้า':this.props.recordType==='export'?'เบิก':'รับเข้าและเบิก')+this.getDate()}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title+(this.props.recordType==='import'?'รับเข้า':this.props.recordType==='export'?'เบิก':'รับเข้าและเบิก')+this.getDate()}
                >
                    {
                        dataList.map((item,index)=>{
                            let items = item // this.getDataFormat(item)
                            return(
                                this.renderComponentPage(items,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportProductTransactionImport.defaultProps = {
    title: 'ตารางรายงานสรุปยอด',  
    mode : '',
    workNo : ''
  }
  export default PrintReportProductTransactionImport;


// WEBPACK FOOTER //
// ./src/view/print/stock/PrintReportProductTransactionImport.js